import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetStudyOlympiads } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { studyOlympiadsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfOlympiadContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentOlympiads = useAppSelector(studyOlympiadsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().studyOlympiads });

  const hasData = studentOlympiads.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentOlympiads, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Олимпиады" Icon={IconWidgetStudyOlympiads}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfOlympiadContainer;
